import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { RentalBalanceService } from './../../../../services/rental/rental-balance.service';

export class formModel {
  companyId: number = 0;
  branchId: number = 0;
}

@Component({
  selector: 'app-reverse-rental-balance',
  templateUrl: './reverse-rental-balance.component.html',
  styleUrls: ['./reverse-rental-balance.component.scss'],
  standalone: false
})
export class ReverseRentalBalanceComponent implements OnInit {
  branchId = 0;
  companyId: number | null = null;
  formReverse: FormGroup = new FormGroup({});
  listBranches: any[] = [];
  listCompanies: any[] = [];

  constructor(private branchService: BranchService,
    private companyService: CompanyService,
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private rentalBalanceService: RentalBalanceService,
    private toastHandlerService: ToastHandlerService) {
    this.getAllLists();
  }

  ngOnInit() {
    this.validateForm(new formModel());
  }

  ngOnDestroy() {
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),
      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number) {
    if (branchId != null) {
      this.branchId = branchId;
    } else {
      this.branchId = 0;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
    } else {
      this.companyId = null;
      this.listBranches = [];
    }
  }

  reverseRentalBalance() {
    if (this.formReverse.valid) {
      Swal.fire({
        title: 'Atención',
        text: "¿Realmente desea revertir la importación de saldos alquiler?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await firstValueFrom(this.rentalBalanceService.reverseImportBalances(this.branchId));
            this.toastHandlerService.showToast('success', `El proceso terminó exitosamente.`);
          } catch (error) {
            console.error('Error al revertir la importación de saldos.', error);
          }
        }
      })

    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatiria.',
        min: 'La compañía es obligatiria.',
      },
      branchId: {
        required: 'La sucursal es obligatiria.',
        min: 'La sucursal es obligatiria.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formReverse.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm(form: formModel) {
    this.formReverse = this.formBuilder.group({
      companyId: [form.companyId, [Validators.required, Validators.min(1)]],
      branchId: [form.branchId, [Validators.required, Validators.min(1)]]
    });
  }
}
